import React, { useEffect, useRef } from 'react';
import { Chart, LineController, CategoryScale, LinearScale, PointElement, LineElement } from 'chart.js';

Chart.register(LineController, CategoryScale, LinearScale, PointElement, LineElement);

const LineChart = (props) => {
  const canvasRef = useRef(null);
  const chartInstanceRef = useRef(null);  // Use useRef

  const { thisMonth, lastMonth } = props;

  useEffect(() => {
    const ctx = canvasRef.current.getContext('2d');

    let labels = [];
    let requiredLength = 29;

    if (labels.length < requiredLength) {
        labels = labels.concat(new Array(requiredLength - labels.length).fill(''));
    }

    const chartData = {
      labels,
      datasets: [
        {
          label: 'LastMonth',
          data: lastMonth,
          borderColor: '#C6C7F8',
          fill: false,
          tension: 0.4,
          pointRadius: 0,
        },
        {
          label: 'ThisMonth',
          data: thisMonth,
          borderColor: '#39CB89',
          fill: false,
          tension: 0.4,
          pointRadius: 0,
        },
      ],
    };

    const chartOptions = {
      scales: {
        x: {
          display: false,
          grid: {
            display: false,
          },
        },
        y: {
          display: false,
          grid: {
            display: false,
          },
          beginAtZero: true,
        },
      },
      plugins: {
        legend: {
          display: false,
        },
      },
      animation: {
        duration: 0
      }
    };

    chartInstanceRef.current = new Chart(ctx, {
      type: 'line',
      data: chartData,
      options: chartOptions,
    });

    return () => {
      if (chartInstanceRef.current) {
        chartInstanceRef.current.destroy();
      }
    };
  }, [thisMonth, lastMonth]);

  return (
    <canvas ref={canvasRef} />
  );
};

export default LineChart;